import React from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";

const RankTable = () => {
  const rankData = useSelector((state) => state.brandLeaderboard.totals?.top_ranking);
  if (!rankData?.length) return null;

  return (
    <div className="rank-lists-wrapper">
      {rankData?.map((elem, idx) => (
        <div key={idx}>
          <h4>{elem.title}</h4>
          <ul className="rank-list">
            {elem.content.map((elem, idx) => (
              <li key={idx}>
                {elem.rank}.{" "}
                <span data-tooltip-content={elem.name} data-tooltip-id={elem.name}>
                  {elem.name}
                </span>
                <Tooltip id={elem.name} />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default RankTable;
